import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { formatScheduleLine } from "helpers/reportSubscriptions";

const useStyles = makeStyles()(() => ({
	row: {
		fontSize: "13px",
		color: "#374151",
	},
	label: {
		fontWeight: 600,
		marginRight: "4px",
	},
}));

const SubscriptionScheduleDisplay = ({ subscription }) => {
	const { classes } = useStyles();
	const line = formatScheduleLine({
		frequency: subscription.frequency,
		days: subscription.daysOfWeek,
		time: subscription.timeOfDay,
		timezone: subscription.timezone,
	});
	return (
		<Typography className={classes.row}>
			<span className={classes.label}>Schedule:</span>
			{line}
		</Typography>
	);
};

export default SubscriptionScheduleDisplay;
